"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookupWidgetBase = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var core_1 = require("@athena-portal/core");
var LookupWidgetBase = /** @class */ (function (_super) {
    __extends(LookupWidgetBase, _super);
    function LookupWidgetBase(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            lookup: {}
        };
        return _this;
    }
    LookupWidgetBase.prototype.fetchLookupValues = function (lookupName) {
        var _this = this;
        this.lookupService.fetchLookupValues(lookupName, "en-UK").subscribe(function (lookupValues) {
            _this.state.lookup[lookupName] = lookupValues;
            _this.setState({ lookup: _this.state.lookup });
        }, function () {
            throw new Error("Error: failed to fetch lookup values for '".concat(lookupName, "' lookup"));
        });
    };
    LookupWidgetBase.prototype.resolveLookupValue = function (lookupName, lookupId) {
        if (!lookupId || !this.state.lookup || !this.state.lookup[lookupName]) {
            return "";
        }
        var listItem = this.state.lookup[lookupName].find(function (listItem) { return "".concat(listItem.id) === "".concat(lookupId); });
        if (!listItem) {
            throw new Error("Error: no item with id '".concat(lookupId, "' found in lookup '").concat(lookupName, "'"));
        }
        return listItem.value;
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], LookupWidgetBase.prototype, "lookupService", void 0);
    return LookupWidgetBase;
}(plugin_journey_1.WidgetBase));
exports.LookupWidgetBase = LookupWidgetBase;
//# sourceMappingURL=LookupWidgetBase.js.map